import React, { useState, useCallback } from 'react'
import Cropper from 'react-easy-crop'
import { useNavigate, useLocation } from "react-router-dom";
import getCroppedImg from '../../functions/cropImage';

export default function CropImage() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(1)
  const [rotation, setRotation] = useState(0)
  const [image, setImage] = useState(state.image)
  const [croppedImage, setCropImage] = useState(null)
  const onCropComplete = useCallback(async (croppedArea, croppedAreaPixels) => {
    console.log(croppedArea, croppedAreaPixels)
    const getCroppedImage = await getCroppedImg(
      image,
      croppedAreaPixels,
      rotation
    )
    setCropImage(getCroppedImage)


  }, [])


  return (

    <>
      <div className='flex justify-between py-[15px] px-[16px] text-[20px]'>
        <div onClick={() => {
          let detail = state
          detail.croppedImage = null
          detail.imageName = null
          navigate('/shop-add-coupon', { state: detail })
        }}>ย้อนกลับ</div>
        <div onClick={() => {
          let detail = state
          detail.croppedImage = croppedImage
          navigate('/shop-add-coupon', { state: detail })
        }
        }>
          ยืนยัน</div>
      </div >
      <div>
        <Cropper
          className="cropContainer"
          image={image}
          crop={crop}
          zoom={zoom}
          aspect={3 / 3}
          onCropChange={setCrop}
          onCropComplete={onCropComplete}
          onZoomChange={setZoom}
          onRotationChange={setRotation}
        />
      </div>

    </>
  );
}